/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { FlexContainer, Heading, Switch, Text, theme } from "@nordcloud/gnui";
import { CloudResource } from "~/views/estate/types";

type CloudResourceSidebarItemListProps = {
  items: CloudResource[];
  onSubmit: (item: CloudResource) => void;
  selectedOptions?: CloudResource[];
};

export function CloudResourcesMultiSelectorItemList({
  items,
  onSubmit,
  selectedOptions = [],
}: CloudResourceSidebarItemListProps) {
  return (
    <>
      {items.map((item) => (
        <SidebarItemContainer key={item.id} onClick={() => onSubmit(item)}>
          <FlexContainer direction="column" alignItems="flex-start">
            <Heading level={4}>{item.name}</Heading>
            <Text size="sm" tag="div" color={theme.color.text.text02}>
              {item.id}
            </Text>
          </FlexContainer>
          <SwitchWrap>
            <Switch
              checked={
                selectedOptions.findIndex(({ id }) => id === item.id) > -1
              }
            />
          </SwitchWrap>
        </SidebarItemContainer>
      ))}
    </>
  );
}

const SidebarItemContainer = styled.div`
  padding: ${theme.spacing.spacing02};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  width: 100%;
  background: none;
  border: none;
  border-bottom: 1px solid ${theme.color.border.border01};
  user-select: none;

  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui03};
  }
`;

const SwitchWrap = styled.div`
  margin-left: auto;
  align-self: center;
  pointer-events: none;
`;
